'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

require('slate');

var _wrapCodeBlockByKey = require('./wrapCodeBlockByKey');

var _wrapCodeBlockByKey2 = _interopRequireDefault(_wrapCodeBlockByKey);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * Wrap current block into a code block.
 */


function wrapCodeBlock(opts, editor) {
  var value = editor.value;
  var startBlock = value.startBlock,
      selection = value.selection; // Convert to code block

  (0, _wrapCodeBlockByKey2.default)(opts, editor, startBlock.key); // Move selection back in the block

  editor.moveToStartOfNode(editor.value.document.getDescendant(startBlock.key)).moveAnchorTo(selection.anchor.offset).moveFocusTo(selection.focus.offset);
  return editor;
}

exports.default = wrapCodeBlock;